module.exports = __webpack_public_path__ + "img/GAME_CARDPAIR2.409cf19d.jpg";